<ion-content>
    <ion-toolbar>
        <div class="header">
            <div class="btn-back-menu" (click)="onBackMenu()">
                <button ion-button clear color="light" no-padding>
                <strong style="color:black !important" class="margin-sides">{{ 'GLOBAL_BACK' | translate
                    }}</strong>
                </button>
            </div>
            <ion-title class="title">Scoreboard</ion-title>
        </div> 
    </ion-toolbar>
        <div class="athletes-list">
            <ion-row class="athlete" *ngFor="let athlete of wallenArray">
                <p>{{athlete.bibNo}}</p> <p>{{athlete.firstName}}</p> <p>{{athlete.lastName}}</p> <p *ngIf="athlete.isTimerStarted && !athlete.isPausedTap">{{athlete.totalTime}}</p> <p *ngIf="athlete.isTimerStarted && athlete.isPausedTap">{{athlete.duration}}</p>
            </ion-row>
            <hr>
        </div>
</ion-content>